export const BUILDERS_COMMON_EN = {
  bcCancel: 'Cancel',
  bcGenerateAndAdd: 'Generate & Add',
  bcSave: 'Save',
  bcSaving: 'Saving...',
  bcSaveAllChanges: 'Save All Changes',
  bcAiCreating: 'AI is creating "{name}"...',

  bcPreviewTitle: 'Preview',
  bcPreviewCollapse: 'Hide preview',
  bcPreviewExpand: 'Show preview',
  bcPreviewTopicLabel: 'Topic',
  bcPreviewTopicCustom: 'Custom topic…',
  bcPreviewTopicCustomPlaceholder: 'Describe the topic for the sample',
  bcPreviewSampleLabel: 'Sample',
  bcPreviewRegenerate: 'Regenerate',
  bcPreviewGenerating: 'Generating…',
  bcPreviewErrorEmptyOutput: 'No sample was returned. Try a different topic.',
  bcPreviewErrorGenerationFailed: 'Could not generate a sample. Please try again.',
  bcPreviewErrorUnknown: 'An unexpected error occurred. Please try again.',
  bcPreviewTopic_council: 'City council vote on housing policy',
  bcPreviewTopic_product: 'Tech product announcement',
  bcPreviewTopic_interview: 'Feature interview opener',
  bcPreviewTopic_breaking: 'Breaking news lede',

  bcRemoveConfirm: 'Are you sure you want to remove "{name}"? This action cannot be undone.',
  bcChangeRequests: 'Change Requests',
  bcChangeRequestsPlaceholder: 'Describe the changes you want to make...'
}

export const BUILDERS_COMMON_DE = {
  bcCancel: 'Abbrechen',
  bcGenerateAndAdd: 'Generieren & Hinzufügen',
  bcSave: 'Speichern',
  bcSaving: 'Speichern...',
  bcSaveAllChanges: 'Alle Änderungen speichern',
  bcAiCreating: 'KI erstellt „{name}"...',

  bcPreviewTitle: 'Vorschau',
  bcPreviewCollapse: 'Vorschau ausblenden',
  bcPreviewExpand: 'Vorschau einblenden',
  bcPreviewTopicLabel: 'Thema',
  bcPreviewTopicCustom: 'Eigenes Thema…',
  bcPreviewTopicCustomPlaceholder: 'Thema für das Beispiel beschreiben',
  bcPreviewSampleLabel: 'Beispiel',
  bcPreviewRegenerate: 'Neu generieren',
  bcPreviewGenerating: 'Generiere…',
  bcPreviewErrorEmptyOutput: 'Es wurde kein Beispiel zurückgegeben. Versuche ein anderes Thema.',
  bcPreviewErrorGenerationFailed: 'Beispiel konnte nicht generiert werden. Bitte erneut versuchen.',
  bcPreviewErrorUnknown: 'Ein unerwarteter Fehler ist aufgetreten. Bitte erneut versuchen.',
  bcPreviewTopic_council: 'Gemeinderatsabstimmung zur Wohnpolitik',
  bcPreviewTopic_product: 'Tech-Produktankündigung',
  bcPreviewTopic_interview: 'Einleitung eines Feature-Interviews',
  bcPreviewTopic_breaking: 'Eilmeldung',

  bcRemoveConfirm:
    'Möchten Sie „{name}" wirklich entfernen? Diese Aktion kann nicht rückgängig gemacht werden.',
  bcChangeRequests: 'Änderungswünsche',
  bcChangeRequestsPlaceholder: 'Beschreiben Sie die gewünschten Änderungen...'
}
